import {
  aFetchSellerBankAccounts,
  selectSellerBankAccountsWhereLoaded,
} from '../../../data/seller-bank-accounts'

import {AppThunkAction} from '../../../types/redux'

import {
  aFetchFinancingOptions,
  selectFinancingOptionsWhereLoaded,
} from '../../../data/financing-options'

export const selectSellerBankAccountItemsArePending = (state: Record<string, any>): boolean =>
  !selectSellerBankAccountsWhereLoaded(state) || !selectFinancingOptionsWhereLoaded(state)

export const aInitializeSellerBankAccountItems =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchSellerBankAccounts())
    dispatch(aFetchFinancingOptions())
  }
